import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        statItem: {
            textAlign: 'left'
        },
        statLabel: {
            fontSize: '0.85rem',
            color: '#5A6A81',
            marginBottom: '6px',
            fontWeight: 500
        },
        statValue: {
            fontSize: '1.15rem',
            fontWeight: 700,
            color: '#1F2152'
        }
    })
);

type StatItemProps = {
    label: string;
    value: number | string;
};

const StatItem: React.FC<StatItemProps> = ({ label, value }) => {
    const classes = useStyles();

    return (
        <div className={classes.statItem}>
            <div className={classes.statLabel}>{label}</div>
            <div className={classes.statValue}>{value}</div>
        </div>
    );
};

export default StatItem; 